export const PASSWORD_MISMATCH_ERR_MSG="Passwords don't match. Please try again."
export const REGISTRATION_SUCCESS="Registration successful! A verification email has been sent. Please check your inbox (and spam folder) to activate your account."
export const REGISTRATION_FAILED="Registration failed. Please check that your email is valid and not already registered, then try again."
export const USER_REGISTRATION_MSG="Not a User? Register Here"
export const FORGOT_PASSWORD_MSG="Forgot password?"
export const LOGIN_FAILED_MSG="Login failed. Please check your email and password, then try again."
export const ADD_SUBJECT_FAILED_ERR_MSG="Failed to add a new subject."
export const ADD_SUBJECT_SUCCESS_MSG="Subject added successfully."
export const ADD_SUBJECT_EMPTY_ERR_MSG="Subject name connot be empty."
export const DELETE_SUBJECT_SUCCESS_MSG="Subject deleted successfully."
export const DELETE_SUBJECT_FAILED_ERR_MSG="Failed to delete subject."
export const RESOURCE_DELETE_TITLE = 'Delete resource?'
export const RESOURCE_DELETE_WARNING_MSG = 'This will permanently delete this resource and its related data. This cannot be undone.'
export const RESOURCE_DELETE_ERROR_MSG = 'Failed to delete resource. Please try again.'
export const SUCCESS_STATUS = 'success'
export const FAILED_STATUS = 'error'
export const INFO_STATUS = 'info'
export const DAILY_LIMIT_EXCEEDED_STATUS = 'daily_limit_exceeded'
export const RESOURCE_TYPE_URL = 'url'
export const RESOURCE_TYPE_PDF = 'pdf'
export const RESOURCE_TYPE_IMG = 'img'
export const RESOURCE_TYPE_TXT = 'txt'
export const RESOURCE_TYPE_DOCX = "docx"
// Resource upload statuses
export const RESOURCE_UPLOAD_STATUS_COMPLETED = 'upload_completed'
export const RESOURCE_UPLOAD_STATUS_START_SUCCESS = 'upload_start_success'
export const RESOURCE_UPLOAD_STATUS_START_FAILED = 'upload_start_failed'
export const RESOURCE_UPLOAD_STATUS_OCR_PARSING = 'ocr_parsing_in_progress'
export const RESOURCE_UPLOAD_STATUS_CONTENT_PARSING = 'content_parsing_in_progress'
export const REFERENCE_LINKS_HEADER = '<p>Reference links:</p>'
export const WS_MESSAGE_DOCUMENT_CONTENT = "document_content"
export const WS_MESSAGE_VOCABULARY_DEFINITION = "vocabulary_definition"
export const WS_MESSAGE_ERROR = "server_error"
export const REQUEST_TYPE_LOAD_DOCUMENT="load_document"
export const REQUEST_TYPE_SENTENCE_ANALYSIS="analyse_sentence"

// Reading Assistance WebSocket message types
export const WS_REQUEST_SUMMARIZE = "summarize_document"
export const WS_REQUEST_GENERATE_QUESTIONS = "generate_questions"
export const WS_MESSAGE_SUMMARY_TOKEN = "summary_token"
export const WS_MESSAGE_SUMMARY_DONE = "summary_complete"
export const WS_MESSAGE_QUESTION = "questions_chunk"
export const WS_MESSAGE_QUESTIONS_DONE = "questions_complete"
export const SAVE_WORD_SUCCESS_MSG = "Word saved successfully."
export const SAVE_WORD_FAILED_ERR_MSG = "Failed to save the word."
export const LOAD_DATA_FAILED_ERR_MSG = "Failed to load data. Make sure you are logged in."
export const LOAD_PDF_FAILED_ERR_MSG = "Error loading document. Please try again."
export const FAVICON_PATH = `${process.env.BASE_URL}media/watercolor_logo.png`
export const CHROME_EXTENSION_URL = "https://chromewebstore.google.com/detail/immersivelang/aniiallgobhjpmhmdifjloahbphkjdik"
export const CONTACT_EMAIL = "myailb.help@gmail.com"
export const MAX_PDF_PAGES = 50
export const VOCABULARY_LOOKUP_TIMEOUT = 20000 // 20 seconds timeout for vocabulary lookup

// Routes that should not display the sidebar
export const ROUTES_WITHOUT_SIDEBAR = [
  '/',
  '/login',
  '/register',
  '/password',
  '/terms-of-use'
]

// Constants for Scenario & Chat
export const DIFFICULTY_BEGINNER = 'Beginner'
export const DIFFICULTY_INTERMEDIATE = 'Intermediate'
export const DIFFICULTY_ADVANCED = 'Advanced'

// Maps difficulty level numbers from API to display names
export const DIFFICULTY_LEVEL_MAP = {
  1: DIFFICULTY_BEGINNER,
  2: DIFFICULTY_INTERMEDIATE,
  3: DIFFICULTY_ADVANCED
}

// Maps difficulty display name to PrimeVue Tag severity colour
export const DIFFICULTY_SEVERITY = {
  [DIFFICULTY_BEGINNER]: 'secondary',
  [DIFFICULTY_INTERMEDIATE]: 'warn',
  [DIFFICULTY_ADVANCED]: 'danger'
}

export const JAPANESE_LANGUAGE_CODE = 'ja'

export const SUBJECT_EMPTY_ERROR_MSG = 'Please enter a topic to continue.'
export const GENERATE_SCENARIOS_ERROR_MSG = 'Failed to generate scenarios. Please try again.'

export const CHAT_SESSION_STARTED_MSG = 'Chat session started'
export const CHAT_SESSION_END_CONFIRM_MSG = 'Are you sure you want to leave? This will end your current chat session.'
export const CHAT_SESSION_MIN_MESSAGES = 3
export const CHAT_SESSION_MIN_MESSAGES_WARNING = `Are you sure? Short conversations produce less useful feedback.`
export const CHAT_SESSION_END_ERROR_MSG = 'Failed to end chat session. Please try again.'
export const CHAT_SESSION_START_ERROR_MSG = 'Failed to start chat session. Please try again.'

// Chat Session Insights
export const INSIGHTS_LOADING_MSG = 'Generating your session insights…'
export const INSIGHTS_LOAD_ERROR_MSG = 'Failed to load insights. Please try again.'
export const INSIGHTS_STILL_ACTIVE_MSG = 'This session is still active. End the session first.'

// Past Conversations
export const CHAT_CONVERSATIONS_EMPTY_STATE_MSG = 'No conversations yet — start your first one!'
export const CHAT_CONVERSATIONS_LOADING_MSG = 'Loading your conversations...'

// AI Feedback
export const FEEDBACK_FEATURE_TYPE_SUMMARY = 'summary'
export const FEEDBACK_FEATURE_TYPE_COMPREHENSION_QUESTION = 'comprehension_question'
export const FEEDBACK_FEATURE_TYPE_VOCABULARY = 'vocabulary'
export const FEEDBACK_FEATURE_TYPE_CHAT_INSIGHTS = 'chat_insights'
export const FEEDBACK_SUBMIT_ERROR_MSG = 'Failed to submit feedback. Please try again.'
export const CHAT_CONVERSATIONS_ERROR_MSG = 'Failed to load conversations'
export const CHAT_CONVERSATION_DELETE_TITLE = 'Delete conversation?'
export const CHAT_CONVERSATION_DELETE_WARNING_MSG = 'This will permanently delete this conversation, including its messages and summary. This cannot be undone.'
export const CHAT_CONVERSATION_DELETE_ERROR_MSG = 'Failed to delete conversation. Please try again.'
export const CHAT_CONVERSATIONS_MAX_ITEMS = 7
export const CHAT_CONVERSATION_LEVEL_TAG_COLOR_MAP = {
  [DIFFICULTY_BEGINNER]: 'success',
  [DIFFICULTY_INTERMEDIATE]: 'warn',
  [DIFFICULTY_ADVANCED]: 'danger'
}
export const INSIGHTS_SOURCE_WEB = 'web'
export const INSIGHTS_SOURCE_LIBRARY = 'library'
export const INSIGHTS_TYPE_RESOURCE = 'resource'

// Voice Reader WebSocket message types
export const WS_REQUEST_READ_PAGE = 'read_page'
export const WS_MESSAGE_SENTENCE_AUDIO_READY = 'sentence_audio_ready'
export const WS_MESSAGE_READ_PAGE_COMPLETE = 'read_page_complete'
export const WS_MESSAGE_VOICE_READER_ERROR = 'voice_reader_error'

// Weekly usage limits
export const VOICE_READER_WEEKLY_LIMIT_MSG = 'Weekly page voice read limit reached'
export const VOICE_READER_WEEKLY_LIMIT_UI_MSG = "You've reached your weekly limit of page reads. Resets on Monday."
export const CHAT_WEEKLY_LIMIT_MSG = 'Weekly chat session limit reached'
export const CHAT_WEEKLY_LIMIT_UI_MSG = "You've reached your weekly limit of chat sessions. Resets on Monday."
export const CHAT_WS_CLOSE_CODE_WEEKLY_LIMIT = 4004

// Generate Resources
export const GENERATE_RESOURCES_MAX_DOCS = 5
export const RESOURCE_STATUS_GENERATION_IN_PROGRESS = 'generation_in_progress'
export const RESOURCE_STATUS_GENERATION_PARSING = 'generation_parsing'
export const RESOURCE_STATUS_GENERATION_COMPLETED = 'generation_completed'
export const RESOURCE_STATUS_GENERATION_FAILED = 'generation_failed'
export const DOCUMENT_TYPE_ARTICLE = 'article'
export const DOCUMENT_TYPE_LESSON_GRAMMAR = 'lesson_grammar'
export const DOCUMENT_TYPE_LESSON_VOCABULARY = 'lesson_vocabulary'
export const DOCUMENT_TYPE_DIALOGUE = 'dialogue'
export const DOCUMENT_TYPE_SHORT_STORY = 'short_story'
export const DOCUMENT_TYPE_NOVEL = 'novel'
export const DOCUMENT_TYPE_NEWS = 'news'
export const DOCUMENT_TYPE_EDUCATIONAL_CONTENT = 'educational_content'
export const GENERATE_RESOURCES_DOC_TYPES = [
  DOCUMENT_TYPE_ARTICLE,
  DOCUMENT_TYPE_LESSON_GRAMMAR,
  DOCUMENT_TYPE_LESSON_VOCABULARY,
  DOCUMENT_TYPE_DIALOGUE,
  DOCUMENT_TYPE_SHORT_STORY,
  DOCUMENT_TYPE_NOVEL,
  DOCUMENT_TYPE_NEWS,
  DOCUMENT_TYPE_EDUCATIONAL_CONTENT
]
export const DOCUMENT_TYPE_DISPLAY_MAP = {
  [DOCUMENT_TYPE_ARTICLE]: 'Article',
  [DOCUMENT_TYPE_LESSON_GRAMMAR]: 'Grammar Lesson',
  [DOCUMENT_TYPE_LESSON_VOCABULARY]: 'Vocabulary Lesson',
  [DOCUMENT_TYPE_DIALOGUE]: 'Dialogue',
  [DOCUMENT_TYPE_SHORT_STORY]: 'Short Story',
  [DOCUMENT_TYPE_NOVEL]: 'Novel',
  [DOCUMENT_TYPE_NEWS]: 'News',
  [DOCUMENT_TYPE_EDUCATIONAL_CONTENT]: 'Educational Content'
}
export const GENERATE_RESOURCES_LINGUISTIC_LEVELS = ['beginner', 'intermediate', 'advanced']
export const GENERATE_RESOURCES_SUCCESS_MSG = 'Resources are being generated and will appear shortly.'
export const GENERATE_RESOURCES_ERROR_MSG = 'Failed to generate resources. Please try again.'
export const GENERATE_RESOURCES_MAX_DOCS_ERROR_MSG = `You can only generate up to ${GENERATE_RESOURCES_MAX_DOCS} documents per week. Please try again next week.`
export const DEFAULT_LANGUAGE = 'Japanese'
export const TOO_MANY_REQUESTS_STATUS = 429

// WebSocket Message Types
export const CHAT_MESSAGE_TYPE_SCENARIO_START = 'scenario_start'
export const CHAT_MESSAGE_TYPE_USER_MESSAGE = 'user_message'
export const CHAT_MESSAGE_TYPE_AI_MESSAGE = 'ai_message'
export const CHAT_MESSAGE_TYPE_SESSION_CREATED = 'session_created'
export const CHAT_MESSAGE_TYPE_SESSION_END = 'session_end'
export const CHAT_MESSAGE_TYPE_ERROR = 'chat_error'
export const CHAT_MESSAGE_TYPE_TYPING = 'typing_indicator'
export const CHAT_MESSAGE_TYPE_CORRECTIONS = 'corrections'
export const CHAT_MESSAGE_TYPE_RAG_ANSWER_CHUNK = 'rag_answer_chunk'

// Audio WebSocket Message Types
export const CHAT_MESSAGE_TYPE_USER_MESSAGE_AUDIO = 'user_message_audio'
export const CHAT_MESSAGE_TYPE_USER_MESSAGE_TRANSCRIBED = 'user_message_transcribed'
export const CHAT_MESSAGE_TYPE_TRANSCRIPTION_FAILED = 'transcription_failed'
export const CHAT_MESSAGE_TYPE_AI_MESSAGE_AUDIO = 'ai_message_audio'
export const CHAT_MESSAGE_TYPE_TTS_FAILED = 'tts_failed'

// Audio Recording Constraints
export const AUDIO_MAX_DURATION_MS = 30000 // 30 seconds
export const AUDIO_MIN_DURATION_MS = 500 // 0.5 seconds
export const AUDIO_SUPPORTED_FORMATS = ['audio/wav', 'audio/mp3', 'audio/ogg', 'audio/webm']
export const AUDIO_MIME_TYPE = 'audio/webm' // Default MIME type for MediaRecorder

// Audio Error Messages
export const AUDIO_RECORDING_START_ERROR = 'Failed to start recording. Please check your microphone permissions.'
export const AUDIO_RECORDING_NOT_SUPPORTED = 'Audio recording is not supported in your browser.'
export const AUDIO_TRANSCRIPTION_FAILED = 'Speech recognition failed. Please try again or type your message.'
export const AUDIO_TTS_FAILED = 'Audio synthesis is temporarily unavailable. Text response is still shown.'
export const AUDIO_DURATION_EXCEEDED = 'Recording time exceeded 30 seconds. Please keep messages under 30 seconds.'
export const AUDIO_EMPTY_RECORDING = 'No audio was recorded. Please try again.'
export const AUDIO_UPLOAD_FAILED = 'Failed to send audio. Please try again.'
